import { Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const CoverLetterPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '1rem' }}>
      <Title order={2}>{t('cover_letter')}</Title>
    </div>
  );
};

export default CoverLetterPage;
